import { ToolRenderer } from "./types";
import { ReadFilesToolRenderer } from "./ReadFilesToolRenderer";
import { ReadFilePartialToolRenderer } from "./ReadFilePartialToolRenderer";
import { GlobToolRenderer } from "./GlobToolRenderer";
import { GrepToolRenderer } from "./GrepToolRenderer";
import {
  SupabaseDeployEdgeFunctionToolRenderer,
  SupabaseRunMigrationToolRenderer,
} from "./SupabaseToolRenderers";
import {
  RunTerminalCommandToolRenderer,
  RestartDevServerToolRenderer,
} from "./TerminalToolRenderers";
import {
  CreateStoryBoardToolRenderer,
  StorySpecGeneratorToolRenderer,
  CreateOrUpdateStoriesToolRenderer,
} from "./StoryboardToolRenderers";
import { TaskToolRenderer, TodoWriteToolRenderer } from "./TaskToolRenderers";
import {
  WebSearchToolRenderer,
  WebFetchToolRenderer,
  SkillToolRenderer,
} from "./WebToolRenderers";
import { DefaultToolRenderer } from "./DefaultToolRenderer";

export const TOOL_RENDERERS: Record<string, ToolRenderer> = {
  readFilesTool: ReadFilesToolRenderer,
  readFilePartialTool: ReadFilePartialToolRenderer,
  globTool: GlobToolRenderer,
  grepTool: GrepToolRenderer,
  supabaseDeployEdgeFunctionTool: SupabaseDeployEdgeFunctionToolRenderer,
  supabaseRunMigrationTool: SupabaseRunMigrationToolRenderer,
  runTerminalCommandTool: RunTerminalCommandToolRenderer,
  restartDevServerTool: RestartDevServerToolRenderer,
  createStoryBoardTool: CreateStoryBoardToolRenderer,
  storySpecGeneratorTool: StorySpecGeneratorToolRenderer,
  createOrUpdateStoriesTool: CreateOrUpdateStoriesToolRenderer,
  taskTool: TaskToolRenderer,
  todoWriteTool: TodoWriteToolRenderer,
  webSearchTool: WebSearchToolRenderer,
  web_search: WebSearchToolRenderer,
  web_fetch: WebFetchToolRenderer,
  Skill: SkillToolRenderer,
};

export const TOOL_HEADINGS: Record<string, string> = {
  readFilesTool: "Read Files",
  readFilePartialTool: "Read File",
  globTool: "Searched Files by Pattern",
  grepTool: "Searched File Contents",
  supabaseDeployEdgeFunctionTool: "Deploy Edge Function",
  supabaseRunMigrationTool: "Run Database Migration",
  runTerminalCommandTool: "Run Terminal Command",
  restartDevServerTool: "Restart Dev Server",
  createStoryBoardTool: "Create Storyboard",
  createOrUpdateStoriesTool: "Create/Update Stories",
  storySpecGeneratorTool: "Generate Story Spec",
  taskTool: "Task Agent",
  todoWriteTool: "Todo List",
  webSearchTool: "Searched Web",
  web_search: "Searched Web",
  web_fetch: "Fetched Web Content",
  Skill: "Loaded Skill",
  createIssueTool: "Create Issue",
  updateIssueTool: "Update Issue",
  deleteIssueTool: "Delete Issue",
  listIssuesTool: "List Issues",
  readIssueTool: "Read Issue",
  exploreCodebaseTool: "Explore Codebase",
};

export { DefaultToolRenderer };
export type { ToolRenderer, ToolRendererProps } from "./types";
